import { getSearchResults } from '../actions';
import { ArticleWithRelations, KBEntity } from '../admin-knowledge-base.type';
import { useCallback, useEffect, useState } from 'react';
import { useForm } from 'antd/lib/form/Form';

interface SearchFromValues {
    query: string;
}

interface Options {
    resetTriggers: KBEntity[];
    onSearch: () => void;
}

export const useSearch = ({ resetTriggers, onSearch }: Options) => {
    const [form] = useForm<SearchFromValues>();
    const [results, setResults] = useState<ArticleWithRelations[] | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [query, setQuery] = useState<string>(null);

    useEffect(() => {
        setResults(null);
        setQuery(null);
    }, [...resetTriggers]);

    const search = useCallback(async ({ query }: SearchFromValues) => {
        try {
            setIsLoading(true);
            const articles = await getSearchResults(query);
            setQuery(query);
            setResults(articles);
            onSearch();
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    const clear = useCallback(() => {
        setResults(null);
        setQuery(null);
        form.resetFields();
    }, []);

    return { form, results, isLoading, query, search, clear };
};
